import { decode } from "../../config";
import { apiFetch } from "../../utils/api";

const API_BASE_URL = decode(window._env_?.API_BASE_URL);

export const getUserWishlist = (obj) => async (dispatch) => {
  try {
    const res = await apiFetch(`${API_BASE_URL}/WishList/GetUserWishlist`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    if (res.status === 204) {
      dispatch({ type: "GET_LISTS_WISHLISTS", payload: null });
      return null;
    }
    const data = await res.json();
    dispatch({ type: "GET_LISTS_WISHLISTS", payload: data });
  } catch (err) {
    console.error("Failed to fetch wishlist:", err);
  }
};

export const addWishlist = (obj) => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/WishList/AddWishlist`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    const data = await response.json();
    dispatch({ type: "ADD_WISHLIST", payload: data });
    return obj;
  } catch (err) {
    console.error("Error adding wishlist details:", err);
  }
};

export const deleteWishlist = (obj) => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/WishList/DeleteWishlist`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    if (!response.ok) {
      throw new Error("Failed to delete wishlist details");
    }

    const data = await response.json();
    dispatch({ type: "DELETE_WISHLIST", payload: data });
    return data;
  } catch (err) {
    console.error("Error delete wishlist details:", err);
  }
};
